import { useMemo } from 'react'
import Modal from '../../shared/modal/Modal'
import useGroupOrders from '../../hooks/useGroupOrders'
import { buildChecklistSections } from '../../utils/checklistSections'

// Pré-visualização do checklist: mesma ordem que a OS vai ter ao ser criada com este procedimento
// (grupos na ordem atual de Grupos de Checklist, itens pelo order do item).
function ProcedureChecklistPreview({ modalStatus, changeStatus, procedure }) {
    const groupOrders = useGroupOrders()
    const sections = useMemo(
        () => buildChecklistSections(procedure?.items || [], groupOrders),
        [procedure, groupOrders]
    )

    return (
        <Modal
            modalStatus={modalStatus}
            changeStatus={changeStatus}
            w={70}
            content={
                <div className="pr-prev">
                    <div className="pr-prev-header">
                        <p className="pr-prev-title">Pré-visualização do checklist</p>
                        <span className="pr-prev-accent" />
                        <span className="pr-prev-subtitle">{procedure?.name}</span>
                    </div>
                    <div className="pr-prev-list">
                        {sections.length > 0 ? sections.map((section) => (
                            <div key={section.groupLabel} className="pr-prev-group">
                                <div className="pr-prev-group-header">{section.groupLabel}</div>
                                {section.items.map((item) => (
                                    <div key={item._id} className="pr-prev-item">{item.name}</div>
                                ))}
                            </div>
                        )) : (
                            <p className="pr-prev-empty">Nenhum item neste procedimento</p>
                        )}
                    </div>
                </div>
            }
        />
    )
}

export default ProcedureChecklistPreview
